import { StyledPaper, StyledTextContainer } from './styles';
import { Text } from '@/components/atoms/text';
import type { ElementType } from 'react';
import type { SvgIconProps } from '@mui/material';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';

interface DimensionAboutProps {
  icon: ElementType<SvgIconProps>;
  title: string;
  description: string;
}

export const DimensionAbout = ({ icon: Icon, title, description }: DimensionAboutProps) => {
  return (
    <StyledPaper variant="outlined">
      <StyledTextContainer>
        <Icon color="action" />

        <Text variant="h6" color="text.primary">
          <SafeMarkdown text={title} />
        </Text>
      </StyledTextContainer>

      <StyledTextContainer gap={0.5}>
        <Text variant="body2" color="text.secondary">
          <SafeMarkdown text={description} />
        </Text>
      </StyledTextContainer>
    </StyledPaper>
  );
};
